import React from "react";
import { Container, Box, Paper, Typography, Button } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";

const Contact: React.FC = () => {
  return (
    <Box
      sx={{
        bgcolor: "#1E1E2F",
        py: 8,
        userSelect: 'none'
      }}
    >
      <Container maxWidth="lg">
        <Paper
          elevation={6}
          sx={{
            bgcolor: "#242435",
            p: { xs: 3, md: 6 },
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            sx={{
              color: "#e0e0e0",
              fontWeight: 600,
              mb: 4,
            }}
          >
            Contact Us
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: "#C0C0C0" }}>
            Have questions or want to chat about trading cards? We're here to help.
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: "#C0C0C0" }}>
            Call us anytime during business hours.
          </Typography>

          {/* Phone Button */}
          <Box mt={4}>
            <Button
              variant="contained"
              href="tel:+18477462273"
              startIcon={<PhoneIcon />}
              sx={{
                bgcolor: "#89C7C8",
                color: "#1E1E2F",
                fontWeight: "bold",
                "&:hover": {
                  bgcolor: "#76b3b4",
                },
              }}
            >
              (847)746-2273
            </Button>
          </Box>

          {/* Email Button */}
          <Box mt={2}>
            <Button
              size="small"
              variant="contained"
              href="mailto:zioncards@aol.com"
              startIcon={<EmailIcon />}
              sx={{
                bgcolor: "#89C7C8",
                color: "#1E1E2F",
                fontWeight: "bold",
                "&:hover": {
                  bgcolor: "#76b3b4",
                },
              }}
            >
              zioncards@aol.com
            </Button>
          </Box>

          {/* Address and Directions Button */}
          <Box mt={4}>
            <Typography
              variant="body1"
              sx={{ color: "#C0C0C0", mb: 1 }}
            >
              1711 Lewis Ave<br />
              Zion, IL 60099
            </Typography>
            <Button
              variant="outlined"
              href="https://www.google.com/maps/dir/?api=1&destination=1711+Lewis+Ave+Zion+IL+60099"
              target="_blank"
              rel="noopener"
              startIcon={<LocationOnIcon />}
              sx={{
                color: "#89C7C8",
                borderColor: "#89C7C8",
                fontWeight: "bold",
                "&:hover": {
                  borderColor: "#76b3b4",
                  color: "#76b3b4",
                },
              }}
            >
              Get Directions
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Contact;
